<template>
  <div class="w-full">
    <ul
      role="list"
      class="divide-y divide-gray-400"
    >
      <li
        v-for="entry in item.balance_entries"
        class="flex py-4"
      >
        <order-item-entry
          :entry="entry"
          :key="entry.id"
          @updated="emitUpdated()"
          @deleted="emitUpdated()"
        />
      </li>

      <li class="py-4">
        <div class="text-base">Attach a Package</div>
        <!-- Search package -->
        <div
          v-if="!selectedPackage"
          class="mt-2"
        >
          <div class="input-group col-span-10 relative">
            <div class="mt-1 flex rounded-md">
              <div class="relative flex items-stretch grow focus-within:z-10">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <SearchIcon
                    class="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </div>
                <input
                  v-model="searchQuery"
                  @blur="handleSearchBlur()"
                  type="text"
                  name="search_packages"
                  id="search_packages"
                  :class="[
                    'focus:ring-blue-600 focus:border-blue-600 block w-full rounded-none rounded-l-md sm:text-sm bg-gray-100 border-gray-400 rounded-r-md pl-10'
                  ]"
                  placeholder="Search Packages"
                />
              </div>
            </div>
          </div>
          <div v-if="searchResults && searchResults.length > 0">
            <div class="flex-1 relative">
              <ul
                ref="results"
                class="space-y-1"
              >
                <div class="search-table-container">
                  <table class="text-sm w-full">
                    <thead>
                      <tr>
                        <th>Package</th>
                        <th class="text-center">Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-if="searching"
                        tabindex="0"
                      >
                        <td colspan="2">
                          <strong>Searching...</strong>
                        </td>
                      </tr>
                      <tr
                        @click="selectPackage(item)"
                        v-if="!searching"
                        v-for="(item, index) in searchResults"
                        class="cursor-pointer text-blue-600"
                        tabindex="0"
                      >
                        <td :class="{ 'text-gray-900': !item.published_at }">
                          {{ item.sub_lot_num }}
                          <small>{{ item.details.name }} | {{ item.details.tag_num }}</small>
                          <div v-if="item.space">
                            <small><strong>Space: </strong>{{ item.space.name }}</small>
                          </div>
                        </td>
                        <td class="text-center">
                          {{ item.quantity_available }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ul>
            </div>
          </div>
        </div>

        <div
          v-if="selectedPackage"
          class="mt-2"
        >
          <div class="mt-2 flex flex-1 items-center justify-start text-sm">
            <div class="pr-2">
              <input
                v-model="addForm.amount"
                type="number"
                step="1"
                min="0"
                class="h-[36px] w-[70px] flex border-2 border-gray-400 rounded-lg pl-4 pr-2 select-none font-semibold text-sm text-gray-800"
              />
            </div>
            <div class="flex flex-1 flex-col">
              <div class="text-sm font-medium text-gray-900">
                {{ selectedPackage.sub_lot_num }}
              </div>
              <div class="text-xs text-gray-600">
                {{ selectedPackage.product_name }}
                <div v-if="selectedPackage.space">
                  <small><strong>Space: </strong>{{ selectedPackage.space.name }}</small>
                </div>
              </div>
            </div>
            <div class="flex ml-6">
              <button
                @click="addPackage()"
                :disabled="adding"
                type="button"
                class="font-medium text-indigo-600 hover:text-indigo-500 mr-4"
              >
                <span v-if="!adding">Add</span>
                <span v-if="adding">Adding...</span>
              </button>
              <button
                @click="clearSelectedPackage()"
                type="button"
                class="font-medium text-indigo-600 hover:text-indigo-500"
              >
                <span>Clear</span>
              </button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import _date from '@/Filters/Date'
import OrderItemEntry from '@/Pages/Orders/Components/OrderItemEntry'
import { SearchIcon } from '@heroicons/vue/solid'

export default {
  components: {
    OrderItemEntry,
    SearchIcon
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    locationId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      searchQuery: null,
      searching: false,
      searchResults: [],
      selectedPackage: null,
      addForm: this.$inertia.form({
        package_id: null,
        amount: 0
      }),
      adding: false
    }
  },

  created() {
    console.log('Created order item manager')
    // @todo: Get packages for order item
  },

  watch: {
    searchQuery() {
      this.search()
    }
  },

  methods: {
    _date,
    emitUpdated() {
      this.$emit('updated')
    },
    /**
     * Searches packages to attach.
     */
    search: _.debounce(
      function () {
        this.searching = true

        axios
          .post(route('packages.search'), {
            query: this.searchQuery,
            origin_id: this.locationId,
            show_unpublished: true,
            show_out_of_stock: true
          })
          .then((response) => {
            this.searchResults = response.data.data || []
            this.searching = false
          })
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),
    handleSearchBlur() {
      setTimeout(() => {
        this.searchResults = []
        this.searching = false
      }, 500)
    },
    clearSearch() {
      this.searchQuery = null
      this.searchResults = []
    },
    selectPackage(pkg) {
      this.selectedPackage = pkg
      this.addForm.reset()
      this.addForm.package_id = pkg.id
      this.clearSearch()
    },
    clearSelectedPackage() {
      this.selectedPackage = null
      this.addForm.reset()
    },
    /**
     * Attaches a selected package at given quantity to order item.
     */
    addPackage() {
      if (this.adding) {
        return
      }

      this.adding = true

      this.addForm.post(route('order-items.packages.store', { orderItem: this.item.id }), {
        onSuccess: (response) => {
          this.$emit('updated', this.entry)
          this.clearSelectedPackage()
        },
        onFinish: (response) => {
          this.adding = false
        }
      })
    }
  }
}
</script>
